import { apiRequest } from "@/data/api/client";
import {
  payloadToPaymentAccount,
  type PaymentAccountPayload,
} from "@/data/mappers/paymentAccount.mapper";
import type { PaymentAccount } from "@/domain/payment-account/types";

export interface OnboardingLink {
  url: string;
  expiresAt: string;
}

export const paymentAccountRepo = {
  /** Re-reads Stripe on the server, so it answers what the partner is actually
   *  waiting for rather than what a webhook last delivered. */
  async get(): Promise<PaymentAccount> {
    const payload = await apiRequest<PaymentAccountPayload>("/v1/partner/payment-account");
    return payloadToPaymentAccount(payload);
  },

  /** Answers the same payload `get` does, so the new account's stage is known
   *  without a second read. Refuses with `ACCOUNT_EXISTS` once one is
   *  connected — a business never gets a second account from here. */
  async create(): Promise<PaymentAccount> {
    const payload = await apiRequest<PaymentAccountPayload>("/v1/partner/payment-account", {
      method: "POST",
    });
    return payloadToPaymentAccount(payload);
  },

  /** Single-use and minutes-lived: minted per click, followed immediately, and
   *  never stored or rendered into a link on page load. */
  startOnboarding(): Promise<OnboardingLink> {
    return apiRequest<OnboardingLink>("/v1/partner/payment-account/link", { method: "POST" });
  },
};
